import React, { useEffect } from "react";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";

import data from "./theme.data";
// import { usePageMode } from "@/model/usePageMode";
import CssBaseline from "@mui/material/CssBaseline";

// const theme = createTheme(data());
const theme2 = createTheme(data("dark"));

// function withRoot(Component, mode) {
function withRoot(Component) {
  function ComponentWrapper(props) {
    // const { mode } = usePageMode();
    // useEffect(() => {
    //   document.documentElement.setAttribute("data-theme", mode);
    // }, [mode]);
    useEffect(() => {
      document.documentElement.setAttribute("data-theme", "dark");
    }, []);
    return (
      <StyledEngineProvider injectFirst>
        {/* <ThemeProvider theme={mode == 'dark' ? theme2 : theme}> */}
        <ThemeProvider theme={theme2}>
          <CssBaseline />
          <Component {...props} />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  return ComponentWrapper;
}

export default withRoot;
